var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpeed = function SvgSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.005 28.125h-3.362V25h4.49l20.329 16.852v7.922L38.982 66.94h-4.339v-3.124h3.203l18.491-15.5v-4.995L38.005 28.125ZM19 25.077h6.051l20.33 16.852v7.922L24.9 67.017H19v-41.94Zm3.125 38.816h1.64l18.491-15.5v-4.995L23.925 28.202h-1.8v35.69ZM48.49 28.125h3.362L70.185 43.32v4.995l-18.491 15.5H48.49v3.124h4.34l20.478-17.166v-7.922L52.98 25h-4.488v3.125Z",
    fill: "currentColor"
  })));
};
export default SvgSpeed;